import { AirportResponse } from '../types/api-responses/airport-response'
import { AirportModel } from '../types/models/airport.model'
import { cityResolver } from './city.resolver'

export function airportResolver(airport: AirportResponse): AirportModel
export function airportResolver(airport: AirportResponse[]): AirportModel[]

export function airportResolver(
  airport: AirportResponse | AirportResponse[],
): AirportModel | AirportModel[] {
  if (Array.isArray(airport)) {
    return airport.map(resolveAirport)
  }
  return resolveAirport(airport)
}

function resolveAirport(airport: AirportResponse): AirportModel {
  return {
    address: airport.address,
    latitude: airport.latitude,
    longitude: airport.longitude,
    name: airport.name,
    // The API can return a null `place_id` (e.g. Antalya Airport). It is only
    // used as a UI identifier (combobox key/value + match lookup), never sent
    // to the backend, so fall back to a stable coordinate-based id to avoid a
    // null key crashing the combobox. Remove once the backend fills place_id.
    place_id: airport.place_id || `${airport.latitude},${airport.longitude}`,
    city: cityResolver(airport.city),
    types: ['airport'],
  }
}
